<template>
    <app-layout nav_type="null">
        <!-- Hero Start -->
        <section class="bg-half-170 bg-light d-table w-100">
            <div class="container">
                <div class="row mt-5 justify-content-center">
                    <div class="col-lg-12 text-center">
                        <div class="pages-heading">
                            <h4 class="title mb-0">Contact Us</h4>
                        </div>
                    </div>
                </div>
<!--                <div class="position-breadcrumb">-->
<!--                    <nav aria-label="breadcrumb" class="d-inline-block">-->
<!--                        <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">-->
<!--                            <li class="breadcrumb-item"><a href="index.html">Landrick</a></li>-->
<!--                            <li class="breadcrumb-item"><a href="#">Page</a></li>-->
<!--                            <li class="breadcrumb-item"><a href="#">Contact</a></li>-->
<!--                            <li class="breadcrumb-item active" aria-current="page">Contact One</li>-->
<!--                        </ul>-->
<!--                    </nav>-->
<!--                </div>-->
            </div>
        </section>
        <!-- Hero End -->

        <!-- Shape Start -->
        <div class="position-relative">
            <div class="shape overflow-hidden text-color-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        <!-- Shape End -->

        <!-- Start Contact -->
        <section class="section pb-0 mb-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 mb-5" v-for="contact in contacts" :key="contact.id">
                        <div class="card border-0 text-center features feature-primary feature-clean">
                            <div class="icons text-center mx-auto">
                                <i :class="contact.icon ? contact.icon : 'uil-info-circle'" class=" uil rounded h3 mb-0"></i>
                            </div>
                            <div class="content mt-4">
                                <h5 class="fw-bold">{{ contact.name ? contact.name : contact.type }}</h5>
                                <a :href="contact.href ? contact.href : '#'" class="read-more">{{ contact.value }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container mt-100 mt-60">
                <div class="row align-items-center">
                    <div class="col-lg-5 col-md-6 pt-2 pt-sm-0 order-2 order-md-1">
                        <div class="card shadow rounded border-0">
                            <div class="card-body py-5">
                                <h4 class="card-title">Get In Touch !</h4>
                                <div class="custom-form mt-3">
                                    <form @submit.prevent="create">
                                        <p id="error-msg" class="mb-0"></p>
                                        <div id="simple-msg"></div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label class="form-label">Name <span class="text-danger">*</span></label>
                                                    <div class="form-icon position-relative">
                                                        <i data-feather="user" class="fea icon-sm icons"></i>
                                                        <input name="name" v-model="item.name" type="text" class="form-control ps-5" placeholder="" :class="{ 'is-invalid': isInvalid('name') }">
                                                        <div class="invalid-feedback" v-if="isInvalid('name')">{{ isInvalid('name') }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label class="form-label">Email <span class="text-danger">*</span></label>
                                                    <div class="form-icon position-relative">
                                                        <i data-feather="mail" class="fea icon-sm icons"></i>
                                                        <input name="email" v-model="item.email" type="email" class="form-control ps-5" placeholder="" :class="{ 'is-invalid': isInvalid('email') }">
                                                        <div class="invalid-feedback" v-if="isInvalid('email')">{{ isInvalid('email') }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label class="form-label">Purpose <span class="text-danger">*</span></label>
                                                    <div class="form-icon position-relative">
                                                        <i data-feather="book" class="fea icon-sm icons"></i>
                                                        <select name="purpose" v-model="item.purpose" class="form-control ps-5" :class="{ 'is-invalid': isInvalid('purpose') }">
                                                            <option value="" disabled>Purpose</option>
                                                            <option v-for="(value, key) in form_options.purpose" :value="key">{{ value }}</option>
                                                        </select>
                                                        <div class="invalid-feedback" v-if="isInvalid('purpose')">{{ isInvalid('purpose') }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label class="form-label">Importance <span class="text-danger">*</span></label>
                                                    <div class="form-icon position-relative">
                                                        <i data-feather="book" class="fea icon-sm icons"></i>
                                                        <select name="importance" v-model="item.importance" class="form-control ps-5" :class="{ 'is-invalid': isInvalid('importance') }">
                                                            <option value="" disabled>Importance</option>
                                                            <option v-for="(value, key) in form_options.importance" :value="key">{{ value }}</option>
                                                        </select>
                                                        <div class="invalid-feedback" v-if="isInvalid('importance')">{{ isInvalid('importance') }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="mb-3">
                                                    <label class="form-label">Phone <span class="text-danger">*</span></label>
                                                    <div class="form-icon position-relative">
                                                        <i data-feather="phone" class="fea icon-sm icons"></i>
                                                        <input name="phone" v-model="item.phone" type="tel" class="form-control ps-5" placeholder="" :class="{ 'is-invalid': isInvalid('phone') }">
                                                        <div class="invalid-feedback" v-if="isInvalid('phone')">{{ isInvalid('phone') }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">

                                                <div class="mb-3">
                                                    <label class="form-label">Message <span class="text-danger">*</span></label>
                                                    <div class="form-icon position-relative">
                                                        <i data-feather="message-circle" class="fea icon-sm icons"></i>
                                                        <textarea name="message" v-model="item.message" rows="4" class="form-control ps-5" placeholder="" :class="{ 'is-invalid': isInvalid('message') }"></textarea>
                                                        <div class="invalid-feedback" v-if="isInvalid('message')">{{ isInvalid('message') }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="d-grid">
                                                    <button type="submit" class="btn btn-primary">Send message</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-7 col-md-6 order-1 order-md-2">
                        <div class="card border-0">
                            <div class="card-body p-0">
                                <img src="/assets/images/contact.svg" class="img-fluid" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </app-layout>
</template>

<script>
import {useToast} from "vue-toastification";
import AppLayout from "../../app-layout.vue";
import {useHead} from "@vueuse/head";

const toast = useToast();

export default {
    components: {
        AppLayout,
    },
    data() {
        return {
            contacts: [],
            item: {
                name: null,
                email: null,
                purpose: null,
                importance: null,
                phone: null,
                message: null
            },
            validationErrors: null,
            error_message: null,
            form_options: {
                purpose: {},
                importance: {}
            }
        };
    },
    created() {
        this.fetchContacts();
        this.fetchFormOptions();
    },
    methods: {
        fetchContacts() {
            const id = toast.info("Fetching contact details...", {icon: "fa-light fa-filter-list"});
            axios.get("contacts_data")
                .then(response => {
                    toast.dismiss(id);
                    this.contacts = response.data.data;
                })
                .catch(error => {
                    toast.dismiss(id);
                    toast.error("Failed to fetch contact details.", {icon: "fa-solid fa-circle-exclamation"});
                });
        },
        fetchFormOptions() {
            const id = toast.info('Getting options...', {icon: 'fa-light fa-filter-list'});
            axios.get('contact_us/create')
                .then(response => {
                    toast.dismiss(id);
                    this.form_options = response.data.elements;
                })
                .catch(error => {
                    toast.dismiss(id);
                    if (error.response) {
                        this.validationErrors = error.response.data.errors;
                    }
                });
        },
        isInvalid(name) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        create() {

            useHead({
                title: 'Contact Us',
            })

            const id = toast.info("Creating...", {icon: "fa-solid fa-cloud-arrow-up"});
            this.validationErrors = null;
            this.error_message = null;

            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });

            axios.post("contact_us", formData)
                .then(response => {
                    toast.dismiss(id);
                    toast.success(response.data.message, {timeout: 3000, icon: "fa-solid fa-circle-check"});
                    this.item = {};
                    this.$router.push({name: "home"});
                })
                .catch(error => {
                    toast.dismiss(id);
                    if (error.response) {
                        this.validationErrors = error.response.data.errors;
                        this.error_message = error.response.data.message;
                        toast.error(error.response.data.message, {
                            timeout: 3000,
                            icon: "fa-solid fa-circle-exclamation"
                        });
                    }
                });
        }
    }
};
</script>

<style scoped>
/* Add any custom styles here if needed */
</style>
